'use strict';

module.exports = function () {
    $(document).ready(function () {
        $('body').on('click', '[data-toggle="content-modal"]', function (e) {
            e.preventDefault();
            if ($('#contentModal').length !== 0) {
                $('#contentModal').remove();
            }
            $.spinner().start();
            $.ajax({
                url: $(this).data('target'),
                type: 'get',
                method: 'GET',
                success: function (html) {
                    $('body').append(html);
                    $('#contentModal').focus();
                    $('body').attr('tabindex', '-1');
                    $('#contentModal :button:last').on('keydown', function (e) {
                        if ($('this:focus') && e.which === 9) {
                            e.preventDefault();
                            $('#contentModal :button:first').focus();
                        }
                    });
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });

        $('body').on('click', '#contentModal button[data-dismiss]', function (e) {
            $('#contentModal').remove();
            $('body').attr('tabindex', '');
            if ($('[data-toggle="content-modal"]') && $('[data-toggle="content-modal"]').length > 0) {
                $('[data-toggle="content-modal"]').focus();
            }
            $.spinner().stop();
        });
    });
};
